import { Draft } from '@reduxjs/toolkit';

import { IManufacturerData } from '../../index';

function getAllFailure(draft: Draft<IManufacturerData>) {
  draft.getAll.config.errorMessage = 'Não foi possível carregar os fabricantes';
  draft.getAll.config.isLoading = false;
}

export default getAllFailure;
